jQuery(document).ready(function($) {
    function loadContentPage(item) {
        var url = item.attr('href');
        $.ajax({
            url: url,
            type: 'GET',
            beforeSend: function() {
                $('.box--item-post').addClass('loading');
            },
            success: function(response) {
                var newContent = $(response).find('.result--item-post').html();
                $('.result--item-post').html(newContent);
            },
            complete: function() {
                $('.box--item-post').removeClass('loading');
                $('html, body').animate({
                    scrollTop: $('.blog--post .list-tag').offset().top - 200
                }, 300);
            },
            error: function(xhr, status, error) {
                console.error('Error:', error);
            }
        });
    }

    $(document).on('click', '.ajax_enable .tags .name-tag', function(e) {
        e.preventDefault();
        var item = $(this);
        $('.list-tag .tag-item').removeClass('selected');
        $(this).parent().addClass('selected');
        loadContentPage(item);
    });

    $(document).on('click', '.ajax_enable .box--item-post .paginate--link.active', function(e) {
        e.preventDefault();
        var item = $(this);
        loadContentPage(item);
    });

    function applyMatchHeight() {
        if (window.innerWidth > 778) {
          $('.blog--post .container--post-items .item--post .item--post-info .meta--data .item--title').matchHeight({
            byRow: false,
            property: 'height',
            target: null,
            remove: false
          });
        } else {
          $('.blog--post .container--post-items .item--post .item--post-info .meta--data .item--title').matchHeight({ remove: true });
        }
      }

     applyMatchHeight();
      $(window).on('resize', function() {
        applyMatchHeight();
      });


});